import { AppContext } from "approot/global/services/context";

interface ErrorPageData {
	message: string,
	details?: string,
	stackTrace?: string
}

class SsoLoginErrorController {
	public errorData: ErrorPageData;
	public environment: string;
	public message: string;
	public details: string;
	public stackTrace: string;
	public ready: boolean;

	/*@ngInject*/
	constructor(
		appContext: AppContext,
		private $location: ng.ILocationService,
		private $http: ng.IHttpService,
		private $q: ng.IQService,
		private language: any
	) {
		this.environment = appContext.environment;
		this.init().then(() => this.onReady());
	}

	init() {
		this.errorData = null;
		let errorId = this.$location.search() && this.$location.search().errId;
		if (errorId) {
			return this.$http.get<ErrorPageData>("/webapi/context/error-data", { params: { errorId } })
				.then((response) => {
					this.errorData = response.data;
				}, () => {
					this.errorData = null;
				});
		}
		return this.$q.reject();
	}

	onReady() {
		if (this.errorData == null || this.errorData == undefined) {
			this.message = this.language.Generic.Common.kUnexpErr;
		}
		else {
			this.message = this.errorData.message;
			this.details = this.errorData.details;
			this.stackTrace = this.errorData.stackTrace;
		}
		this.ready = true;
	}

	goBack() {
		this.$location.path("/authorize");
	}
}

export const SsoLoginErrorComponent = {
	controller: SsoLoginErrorController,
	controllerAs: "$ctrl",
	template: `
		<loader ng-hide="$ctrl.ready"></loader>
		<main class="main">
			<div class="form h348" ng-if="$ctrl.ready">
				<a href class="backbutton" ng-click="$ctrl.goBack()">
					<img class="backbutton-icon" src="/static/dist/app/login/img/back.png">
				</a>
				<div class="form__headertext">{{$ctrl.language.Generic.Login.kErrorLoginGosService}}</div>
				<div class="hinttext">
					<div class="hinttext__header">
						<span>{{$ctrl.message}}</span>
						<div ng-if="$ctrl.environment != 'prod' && ($ctrl.details || $ctrl.stackTrace)" class="debug-panel">
							<span ng-if="$ctrl.details" class="title">Details:</span><div>{{$ctrl.details}}</div>
							<span ng-if="$ctrl.stackTrace" class="title">StackTrace:</span><div class="stack">{{$ctrl.stackTrace}}</div>
						</div>
					</div>
				</div>
			</div>
		</main>
	`
}